import type { CPU } from '../CPU';
import { PSW_C, PSW_Z, PSW_S, PSW_OV, PSW_HC, H_IE } from './constants';

export function add8(cpu: CPU): void {
  const op8_0 = cpu.impl_operands[0].value & 0xFF;
  const op8_1 = cpu.impl_operands[1].value & 0xFF;
  const c_in = (cpu.impl_flags_in & PSW_C) ? 1 : 0;

  const carry_8 = ((op8_0 & 0xFF) + (op8_1 & 0xFF) + c_in) >> 8;
  const carry_7 = ((op8_0 & 0x7F) + (op8_1 & 0x7F) + c_in) >> 7;
  const carry_4 = ((op8_0 & 0x0F) + (op8_1 & 0x0F) + c_in) >> 4;

  cpu.impl_flags_changed |= PSW_C | PSW_OV | PSW_HC;
  cpu.impl_flags_out = (cpu.impl_flags_out & ~PSW_C) | (carry_8 ? PSW_C : 0);
  cpu.impl_flags_out = (cpu.impl_flags_out & ~PSW_OV) | ((carry_8 ^ carry_7) ? PSW_OV : 0);
  cpu.impl_flags_out = (cpu.impl_flags_out & ~PSW_HC) | (carry_4 ? PSW_HC : 0);

  cpu.impl_operands[0].value = (op8_0 + op8_1 + c_in) & 0xFF;
}

export function zsCheck(cpu: CPU): void {
  cpu.impl_flags_changed |= PSW_Z | PSW_S;
  if (cpu.impl_operands[0].value & 0xFF)
    cpu.impl_flags_out &= ~PSW_Z;
  cpu.impl_flags_out = (cpu.impl_flags_out & ~PSW_S) | ((cpu.impl_operands[0].value & 0x80) ? PSW_S : 0);
}

export function opADD(cpu: CPU): void {
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  opADDC(cpu);
}

export function opADDC(cpu: CPU): void {
  add8(cpu);
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
}

export function opADD16(cpu: CPU): void {
  if (cpu.impl_hint & H_IE) {
    cpu.impl_operands[1].value |= (cpu.impl_operands[1].value & 0x40) ? 0xFF80 : 0;
  }
  cpu.impl_flags_in &= ~PSW_C;

  const op_high_0 = cpu.impl_operands[0].value >> 8;
  const op_high_1 = cpu.impl_operands[1].value >> 8;
  add8(cpu);
  zsCheck(cpu);

  cpu.impl_flags_in = (cpu.impl_flags_in & ~PSW_C) | (cpu.impl_flags_out & PSW_C);

  const op_low_0 = cpu.impl_operands[0].value;
  cpu.impl_operands[0].value = op_high_0;
  cpu.impl_operands[1].value = op_high_1;
  add8(cpu);
  zsCheck(cpu);

  cpu.impl_operands[0].value = (cpu.impl_operands[0].value << 8) | op_low_0;
}

export function opSUB(cpu: CPU): void {
  cpu.impl_flags_in &= ~PSW_C;
  cpu.impl_flags_in |= PSW_Z;
  opSUBC(cpu);
}

export function opSUBC(cpu: CPU): void {
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  if (!(cpu.impl_flags_in & PSW_Z))
    cpu.impl_flags_out &= ~PSW_Z;
  zsCheck(cpu);
}

export function opCMP16(cpu: CPU): void {
  cpu.impl_flags_in &= ~PSW_C;

  const op_high_0 = cpu.impl_operands[0].value >> 8;
  const op_high_1 = cpu.impl_operands[1].value >> 8;
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  zsCheck(cpu);

  cpu.impl_flags_in = (cpu.impl_flags_in & ~PSW_C) | (cpu.impl_flags_out & PSW_C);

  const op_low_0 = cpu.impl_operands[0].value;
  cpu.impl_operands[0].value = op_high_0;
  cpu.impl_operands[1].value = op_high_1;
  cpu.impl_operands[0].value ^= 0xFF;
  add8(cpu);
  cpu.impl_operands[0].value ^= 0xFF;
  zsCheck(cpu);

  cpu.impl_operands[0].value = (cpu.impl_operands[0].value << 8) | op_low_0;
}
